import { PassengerType } from "@b2bportal/core-types";
import { Product } from "@b2bportal/purchase-api";
import type { FiatPrice } from "@hopper-b2b/types";
import type {
  HsbcPriceLineData,
  PriceBreakdownProps,
} from "@hsbc/core-flights";

const twoFractionOptions: Intl.NumberFormatOptions = {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
};

interface AdditionalFee {
  key: string;
  price: FiatPrice;
}

interface AddAdditionalFeesParams {
  priceLineItems: PriceBreakdownProps["priceLineItems"];
  tripPriceLineItems: HsbcPriceLineData[];
  additionalFees: AdditionalFee[];
  formatFiatCurrency: (
    price: FiatPrice,
    options?: Intl.NumberFormatOptions
  ) => string;
}

export const addAdditionalFeesToPriceLineItems = ({
  priceLineItems,
  tripPriceLineItems,
  additionalFees,
  formatFiatCurrency,
}: AddAdditionalFeesParams): PriceBreakdownProps["priceLineItems"] => {
  if (!additionalFees.length) return priceLineItems;

  const additionalFeesTotal = additionalFees.reduce(
    (total, fee) => total + fee.price.value,
    0
  );

  return priceLineItems.map((priceLineItem, index) => {
    const tripPriceLineItem = tripPriceLineItems[index];

    if (
      !priceLineItem.products ||
      tripPriceLineItem?.passengerType === PassengerType.InfantInLap
    ) {
      return priceLineItem;
    }

    const total = tripPriceLineItem?.total?.fiat;
    const person = tripPriceLineItem?.person;

    return {
      ...priceLineItem,
      lineTitle:
        total && person
          ? `${person.givenName} ${person.surname} [${formatFiatCurrency(
              { ...total, value: total.value + additionalFeesTotal },
              twoFractionOptions
            )}]`
          : priceLineItem.lineTitle,
      products: [
        ...priceLineItem.products,
        ...additionalFees.map((fee) => ({
          label: fee.key,
          value: formatFiatCurrency(fee.price, twoFractionOptions),
          type: Product.Cart,
        })),
      ],
    };
  });
};
